<script>
  // import {getExampleData, exampledata} from '$lib/stores/example.svelte.js';
  // import Scrolly from '$lib/components/Scrolly.svelte'

  let videoEl = $state(null)
  let currentTime = $state(0)

  const timingData = $state({
  "segmentDuration": 0.3125,
  "sourceSegmentSeconds": 5,
  "speedupFactor": 16,
  "segments": [
    {
      "start": 0,
      "label": "Thursday 19 March 2026, 10am (GMT+10)",
      "date": "20260319",
      "hour": "000"
    },
    {
      "start": 0.3125,
      "label": "Thursday 19 March 2026, 1pm (GMT+10)",
      "date": "20260319",
      "hour": "003"
    },
    {
      "start": 0.625,
      "label": "Thursday 19 March 2026, 4pm (GMT+10)",
      "date": "20260319",
      "hour": "006"
    },
    {
      "start": 0.9375,
      "label": "Thursday 19 March 2026, 7pm (AEST)",
      "date": "20260319",
      "hour": "009"
    },
    {
      "start": 1.25,
      "label": "Thursday 19 March 2026, 10pm (AEST)",
      "date": "20260319",
      "hour": "012"
    },
    {
      "start": 1.5625,
      "label": "Friday 20 March 2026, 1am (AEST)",
      "date": "20260319",
      "hour": "015"
    },
    {
      "start": 1.875,
      "label": "Friday 20 March 2026, 4am (AEST)",
      "date": "20260319",
      "hour": "018"
    },
    {
      "start": 2.1875,
      "label": "Friday 20 March 2026, 7am (AEST)",
      "date": "20260319",
      "hour": "021"
    },
    {
      "start": 2.5,
      "label": "Friday 20 March 2026, 10am (AEST)",
      "date": "20260320",
      "hour": "000"
    },
    {
      "start": 2.8125,
      "label": "Friday 20 March 2026, 1pm (AEST)",
      "date": "20260320",
      "hour": "003"
    },
    {
      "start": 3.125,
      "label": "Friday 20 March 2026, 4pm (AEST)",
      "date": "20260320",
      "hour": "006"
    },
    {
      "start": 3.4375,
      "label": "Friday 20 March 2026, 7pm (AEST)",
      "date": "20260320",
      "hour": "009"
    },
    {
      "start": 3.75,
      "label": "Friday 20 March 2026, 10pm (AEST)",
      "date": "20260320",
      "hour": "012"
    },
    {
      "start": 4.0625,
      "label": "Saturday 21 March 2026, 1am (AEST)",
      "date": "20260320",
      "hour": "015"
    },
    {
      "start": 4.375,
      "label": "Saturday 21 March 2026, 4am (AEST)",
      "date": "20260320",
      "hour": "018"
    },
    {
      "start": 4.6875,
      "label": "Saturday 21 March 2026, 7am (AEST)",
      "date": "20260320",
      "hour": "021"
    },
    {
      "start": 5,
      "label": "Saturday 21 March 2026, 12:30 pm (ACST)",
      "date": "20260321",
      "hour": "003"
    },
    {
      "start": 5.3125,
      "label": "Saturday 21 March 2026, 3:30 pm (ACST)",
      "date": "20260321",
      "hour": "006"
    },
    {
      "start": 5.625,
      "label": "Saturday 21 March 2026, 6:30 pm (ACST)",
      "date": "20260321",
      "hour": "009"
    },
    {
      "start": 5.9375,
      "label": "Saturday 21 March 2026, 9:30 pm (ACST)",
      "date": "20260321",
      "hour": "012"
    },
    {
      "start": 6.25,
      "label": "Sunday 22 March 2026, 12:30 am (ACST)",
      "date": "20260321",
      "hour": "015"
    },
    {
      "start": 6.5625,
      "label": "Sunday 22 March 2026, 3:30 am (ACST)",
      "date": "20260321",
      "hour": "018"
    },
    {
      "start": 6.875,
      "label": "Sunday 22 March 2026, 6:30 am (ACST)",
      "date": "20260321",
      "hour": "021"
    },
    {
      "start": 7.1875,
      "label": "Sunday 22 March 2026, 9:30 am (ACST)",
      "date": "20260322",
      "hour": "000"
    },
    {
      "start": 7.5,
      "label": "Sunday 22 March 2026, 12:30 pm (ACST)",
      "date": "20260322",
      "hour": "003"
    },
    {
      "start": 7.8125,
      "label": "Sunday 22 March 2026, 3:30 pm (ACST)",
      "date": "20260322",
      "hour": "006"
    },
    {
      "start": 8.125,
      "label": "Sunday 22 March 2026, 6:30 pm (ACST)",
      "date": "20260322",
      "hour": "009"
    },
    {
      "start": 8.4375,
      "label": "Sunday 22 March 2026, 9:30 pm (ACST)",
      "date": "20260322",
      "hour": "012"
    },
    {
      "start": 8.75,
      "label": "Monday 23 March 2026, 12:30 am (ACST)",
      "date": "20260322",
      "hour": "015"
    },
    {
      "start": 9.0625,
      "label": "Monday 23 March 2026, 3:30 am (ACST)",
      "date": "20260322",
      "hour": "018"
    },
    {
      "start": 9.375,
      "label": "Monday 23 March 2026, 6:30 am (ACST)",
      "date": "20260322",
      "hour": "021"
    },
    {
      "start": 9.6875,
      "label": "Monday 23 March 2026, 9:30 am (ACST)",
      "date": "20260323",
      "hour": "000"
    },
    {
      "start": 10,
      "label": "Monday 23 March 2026, 11am (AWST)",
      "date": "20260323",
      "hour": "003"
    },
    {
      "start": 10.3125,
      "label": "Monday 23 March 2026, 2pm (AWST)",
      "date": "20260323",
      "hour": "006"
    },
    {
      "start": 10.625,
      "label": "Monday 23 March 2026, 5pm (AWST)",
      "date": "20260323",
      "hour": "009"
    },
    {
      "start": 10.9375,
      "label": "Monday 23 March 2026, 8pm (AWST)",
      "date": "20260323",
      "hour": "012"
    },
    {
      "start": 11.25,
      "label": "Monday 23 March 2026, 11pm (AWST)",
      "date": "20260323",
      "hour": "015"
    },
    {
      "start": 11.5625,
      "label": "Tuesday 24 March 2026, 2am (AWST)",
      "date": "20260323",
      "hour": "018"
    },
    {
      "start": 11.875,
      "label": "Tuesday 24 March 2026, 5am (AWST)",
      "date": "20260323",
      "hour": "021"
    },
    {
      "start": 12.1875,
      "label": "Tuesday 24 March 2026, 8am (AWST)",
      "date": "20260324",
      "hour": "000"
    },
    {
      "start": 12.5,
      "label": "Tuesday 24 March 2026, 11am (AWST)",
      "date": "20260324",
      "hour": "003"
    },
    {
      "start": 12.8125,
      "label": "Tuesday 24 March 2026, 2pm (AWST)",
      "date": "20260324",
      "hour": "006"
    },
    {
      "start": 13.125,
      "label": "Tuesday 24 March 2026, 5pm (AWST)",
      "date": "20260324",
      "hour": "009"
    },
    {
      "start": 13.4375,
      "label": "Tuesday 24 March 2026, 8pm (AWST)",
      "date": "20260324",
      "hour": "012"
    },
    {
      "start": 13.75,
      "label": "Tuesday 24 March 2026, 11pm (AWST)",
      "date": "20260324",
      "hour": "015"
    },
    {
      "start": 14.0625,
      "label": "Wednesday 25 March 2026, 2am (AWST)",
      "date": "20260324",
      "hour": "018"
    },
    {
      "start": 14.375,
      "label": "Wednesday 25 March 2026, 5am (AWST)",
      "date": "20260324",
      "hour": "021"
    },
    {
      "start": 14.6875,
      "label": "Wednesday 25 March 2026, 8am (AWST)",
      "date": "20260325",
      "hour": "000"
    },
    {
      "start": 15,
      "label": "Wednesday 25 March 2026, 11am (AWST)",
      "date": "20260325",
      "hour": "003"
    },
    {
      "start": 15.3125,
      "label": "Wednesday 25 March 2026, 2pm (AWST)",
      "date": "20260325",
      "hour": "006"
    },
    {
      "start": 15.625,
      "label": "Wednesday 25 March 2026, 5pm (AWST)",
      "date": "20260325",
      "hour": "009"
    },
    {
      "start": 15.9375,
      "label": "Wednesday 25 March 2026, 8pm (AWST)",
      "date": "20260325",
      "hour": "012"
    },
    {
      "start": 16.25,
      "label": "Wednesday 25 March 2026, 11pm (AWST)",
      "date": "20260325",
      "hour": "015"
    },
    {
      "start": 16.5625,
      "label": "Thursday 26 March 2026, 2am (AWST)",
      "date": "20260325",
      "hour": "018"
    },
    {
      "start": 16.875,
      "label": "Thursday 26 March 2026, 5am (AWST)",
      "date": "20260325",
      "hour": "021"
    },
    {
      "start": 17.1875,
      "label": "Thursday 26 March 2026, 8am (AWST)",
      "date": "20260326",
      "hour": "000"
    },
    {
      "start": 17.5,
      "label": "Thursday 26 March 2026, 11am (AWST)",
      "date": "20260326",
      "hour": "003"
    },
    {
      "start": 17.8125,
      "label": "Thursday 26 March 2026, 2pm (AWST)",
      "date": "20260326",
      "hour": "006"
    },
    {
      "start": 18.125,
      "label": "Thursday 26 March 2026, 5pm (AWST)",
      "date": "20260326",
      "hour": "009"
    },
    {
      "start": 18.4375,
      "label": "Thursday 26 March 2026, 8pm (AWST)",
      "date": "20260326",
      "hour": "012"
    },
    {
      "start": 18.75,
      "label": "Thursday 26 March 2026, 11pm (AWST)",
      "date": "20260326",
      "hour": "015"
    },
    {
      "start": 19.0625,
      "label": "Friday 27 March 2026, 2am (AWST)",
      "date": "20260326",
      "hour": "018"
    },
    {
      "start": 19.375,
      "label": "Friday 27 March 2026, 5am (AWST)",
      "date": "20260326",
      "hour": "021"
    },
    {
      "start": 19.6875,
      "label": "Friday 27 March 2026, 8am (AWST)",
      "date": "20260327",
      "hour": "000"
    },
    {
      "start": 20,
      "label": "Friday 27 March 2026, 11am (AWST)",
      "date": "20260327",
      "hour": "003"
    },
    {
      "start": 20.3125,
      "label": "Friday 27 March 2026, 2pm (AWST)",
      "date": "20260327",
      "hour": "006"
    },
    {
      "start": 20.625,
      "label": "Friday 27 March 2026, 5pm (AWST)",
      "date": "20260327",
      "hour": "009"
    },
    {
      "start": 20.9375,
      "label": "Friday 27 March 2026, 8pm (AWST)",
      "date": "20260327",
      "hour": "012"
    },
    {
      "start": 21.25,
      "label": "Friday 27 March 2026, 11pm (AWST)",
      "date": "20260327",
      "hour": "015"
    },
    {
      "start": 21.5625,
      "label": "Saturday 28 March 2026, 2am (AWST)",
      "date": "20260327",
      "hour": "018"
    },
    {
      "start": 21.875,
      "label": "Saturday 28 March 2026, 5am (AWST)",
      "date": "20260327",
      "hour": "021"
    },
    {
      "start": 22.1875,
      "label": "Saturday 28 March 2026, 8am (AWST)",
      "date": "20260328",
      "hour": "000"
    },
    {
      "start": 22.5,
      "label": "Saturday 28 March 2026, 11am (AWST)",
      "date": "20260328",
      "hour": "003"
    },
    {
      "start": 22.8125,
      "label": "Saturday 28 March 2026, 2pm (AWST)",
      "date": "20260328",
      "hour": "006"
    },
    {
      "start": 23.125,
      "label": "Saturday 28 March 2026, 5pm (AWST)",
      "date": "20260328",
      "hour": "009"
    },
    {
      "start": 23.4375,
      "label": "Saturday 28 March 2026, 8pm (AWST)",
      "date": "20260328",
      "hour": "012"
    },
    {
      "start": 23.75,
      "label": "Saturday 28 March 2026, 11pm (AWST)",
      "date": "20260328",
      "hour": "015"
    },
    {
      "start": 24.0625,
      "label": "Sunday 29 March 2026, 2am (AWST)",
      "date": "20260328",
      "hour": "018"
    },
    {
      "start": 24.375,
      "label": "Sunday 29 March 2026, 5am (AWST)",
      "date": "20260328",
      "hour": "021"
    },
    {
      "start": 24.6875,
      "label": "Sunday 29 March 2026, 8am (AWST)",
      "date": "20260328",
      "hour": "024"
    }
  ]
}
)

  function getCurrentLabel(time) {
    const segments = timingData.segments
    if (!segments?.length) return ""
    const segment = segments.filter((s) => s.start <= time).pop()
    return segment?.label ?? segments[0].label
  }

  const currentLabel = $derived(getCurrentLabel(currentTime))

  $effect(() => {
    const video = videoEl
    if (!video) return
    const updateTime = () => {
      currentTime = video.currentTime
    }
    video.addEventListener("timeupdate", updateTime)
    video.addEventListener("seeked", updateTime)
    updateTime()
    return () => {
      video.removeEventListener("timeupdate", updateTime)
      video.removeEventListener("seeked", updateTime)
    }
  })

  let { name } = $props()
</script>


<div class="vis-chart-headline">Tropical Cyclone Narelle wind speed map</div>
    
<div class="vis-chart-standfirst">Showing wind conditions every three hours, as modelled by the US National Oceanic and Atmospheric Administration. 
  Last updated 29 March 2026, 8am (AWST)
</div>	

<div class="atom">
  <div class="video_wrapper">
    <video
      bind:this={videoEl}
      src="https://interactive.guim.co.uk/embed/aus/2026/03/cyclone-video/output_620w.mp4"
      muted
      autoplay
      playsinline
      loop
    ></video>
  </div>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="overlayLayer s-b0deblwLckhp"
    viewBox="0 0 860 860"
    width="860"
    height="860"
  >
    <text
      class="overlay-label"
      text-anchor="middle"
      dy="-0.2em"
      x="431.82648088697346"
      y="430.84315752712206"
      style="fill: rgba(0, 0, 0, 0.95); stroke: rgba(255, 255, 255, 0.65); stroke-width: 3; paint-order: stroke;"
      >Coen</text
    ><text
      class="overlay-label"
      text-anchor="middle"
      dy="-0.2em"
      x="557.2414495549332"
      y="587.9981373361239"
      style="fill: rgba(0, 0, 0, 0.95); stroke: rgba(255, 255, 255, 0.65); stroke-width: 3; paint-order: stroke;"
      >Cairns</text
    ><text
      class="overlay-label"
      text-anchor="middle"
      dy="-0.2em"
      x="652.7254747426434"
      y="702.9662410448345"
      style="fill: rgba(0, 0, 0, 0.95); stroke: rgba(255, 255, 255, 0.65); stroke-width: 3; paint-order: stroke;"
      >Townsville</text
    ></svg
  >

  <div class="timing-label">{currentLabel}</div>
</div>

<div class="vis-chart-source">Guardian graphic. Source: NOAA GFS. Based on the Nullschool Earth map
</div>	

<style lang="scss">
  .atom {
    width: 100%;
    max-width: 860px;
    aspect-ratio: 1 / 1;
    position: relative;
    font-family: "Guardian Text Sans Web", "Agate Sans", "sans-serif";

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      pointer-events: none;
      display: none;

      text {
        font-family: "Guardian Text Sans Web", "Agate Sans", "sans-serif";
      }
    }

    .video_wrapper {
      position: absolute;
      inset: 0;
      z-index: 1;

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .timing-label {
      position: absolute;
      bottom: 1rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3;
      color: rgba(0, 0, 0, 0.95);
      pointer-events: none;
      font-size: 16px;

      @include mq($until: tablet) {
        font-size: 16px;
      }
    }
  }
  @include mq($until: tablet) {
    .overlay-label {
      font-size: 20px !important;
      stroke-width: 4 !important;
      font-family: "Guardian Text Sans Web", "Agate Sans", "sans-serif";
    }

    .timing-label {
      font-size: 18px;
    }
  }

  .timing-label {
      font-size: 18px;
      font-family: "Guardian Text Sans Web", "Agate Sans", "sans-serif";
    }

</style>
